// generated from 13_573 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const phoneNumberFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("phone_number_filter"),
  comparison_key: z.enum([
    "11", // 9_379 (69.10%)
    "10", // 1_750 (12.89%)
    "2", // 660 (4.86%)
    "17", // 503 (3.71%)
    "1", // 424 (3.12%)
    "12", // 338 (2.49%)
    "25", // 262 (1.93%)
    "26", // 257 (1.89%)
  ]),
  display_name: z.string(),
  // undefined: 5_244 (38.64%), defined 8_329 (61.36%)
  raw_value: z
    .union([
      // string samples: 7_987 (95.89%)
      z.string(),
      // array samples: 342 (4.11%)
      z.array(
        // format integer: 1_298 (99.01%)
        z.string()
      ),
    ])
    .optional(),
  value: z.union([
    // string samples: 13_054 (96.18%)
    z.string(),
    // array samples: 519 (3.82%)
    z.array(
      // format integer: 1_636 (80.43%)
      z.string()
    ),
  ]),
  varies_by_app_group: z.literal(false),
});
